import React from 'react';
import { Link, NavLink } from 'react-router-dom';
import { connect } from 'react-redux';
import { userActions, cocktailActions } from '../_actions';


class IngredientSlide extends React.Component {


  constructor(props) {
    super(props);

    const { user } = this.props;

    this.state = {
      userModified: {
        first_name: user.first_name,
        last_name: user.last_name,
        email: user.email,
        cabinet: user.cabinet,
        access_level: user.access_level,
        keyIngredients: user.keyIngredients ? user.keyIngredients : [],
        _id: user._id
      }
    };

  }

  onKeyIngredientClick(machine_name) {
    const { user, shoppingList } = this.props;

    if (shoppingList) {
      window.open(`https://www.walmart.com/search?query=${machine_name.replace("_", "+")}`);
    } else {

      console.log("Here is key Ingredients 1:", user.keyIngredients);

      let index = user.keyIngredients.indexOf(machine_name);
      if (index > -1) {
        user.keyIngredients.splice(index, 1);
      } else {
        user.keyIngredients.push(machine_name);
      }

      console.log("Here is key Ingredients 2:", user.keyIngredients);
      let userModifiedNew = {
        ...user,
        ['keyIngredients']: user.keyIngredients
      };

      const {dispatch} = this.props;

      console.log("Update this now mod!", userModifiedNew);
      dispatch(userActions.update(userModifiedNew, false));
      dispatch(cocktailActions.getMyRecipes(userModifiedNew.cabinet, userModifiedNew.keyIngredients));
    }

  }

  removeFromCabinetChild(machine_name) {

    const { user } = this.props;

    // remove from cabinet
    const toDelete = new Set(machine_name);
    let cabinet = user.cabinet.filter(ingredientItem => !toDelete.has(ingredientItem.machine_name));
    let indexCabinet = cabinet.indexOf(machine_name);    // <-- Not supported in <IE9
    if (indexCabinet !== -1) {
      cabinet.splice(indexCabinet, 1);
    }
    console.log("Does cabinet have this?", machine_name, cabinet);

    // remove from keyIngredients
    let indexKeyIngred = -1;
    if (user.keyIngredients) {
      indexKeyIngred = user.keyIngredients.indexOf(machine_name);
    }
    if (indexKeyIngred > -1) {
      user.keyIngredients.splice(indexKeyIngred, 1);
    }

    let userModifiedNew = {
      ...user,
      ['cabinet']: cabinet,
      ['keyIngredients']: user.keyIngredients
    };
    console.log("removeFromCabinetChild Here ya go!", userModifiedNew);

    const { dispatch } = this.props;
    if (userModifiedNew.first_name) {
      console.log("Update this now mod!", userModifiedNew);
      dispatch(userActions.update(userModifiedNew, false, `${machine_name.replace(/_/g, ' ').capitalize()} removed from your bar!`));
      dispatch(cocktailActions.getMyRecipes(userModifiedNew.cabinet, userModifiedNew.keyIngredients));
    }
  }

  render() {

    const {match, noLink, ingredients, showCabinetRemove, showRecipeRemove, linkToIngredient, youGotThis, displayBorder, shoppingList} = this.props;

    // BEGIN
    let machine_name = '';
    if (match.hasOwnProperty('params')) {
      machine_name = match.params.machine_name;
    } else {
      machine_name = match;
    }
    const isIngredient = p => p.machine_name === machine_name
    const ingredient = ingredients.items.find(isIngredient)
    // END

    if (!ingredient) {
      // remove abandoned products from users cabinet
      this.removeFromCabinetChild(machine_name)
      return <div>The ingredient {machine_name} is no longer available, so has been removed from your cabinet.</div>
    }

    // !showCabinetRemove && !showRecipeRemove && !modalIngredientList
    if (shoppingList && ingredient.amazon) {
      return (
        <div style={{whiteSpace: 'normal', display: 'inline-block', position: 'relative', height: '240px', width: '120px'}}>
          <div dangerouslySetInnerHTML={{__html: ingredient.amazon}}/>
          <div style={{background: 'linear-gradient(to bottom,#f8e6b8 0,#f3d686 6%,#ebb62c 100%)', fontSize: '12px', padding: '5px', bottom: '0px', right: '0px', width: '90px', height: '30px', position: 'absolute', boxSizing: 'border-box'}}>{ingredient.name}</div>
        </div>
      )
    }

    let ingredientRendered = (
<div style={{background: `url(${ingredient.img_url}) no-repeat center/cover`, border: (displayBorder?'5px solid purple':'none'), position: 'relative', height: `20rem`, cursor: 'pointer', width: '55px'}}>
          {typeof(youGotThis) === "boolean" && youGotThis &&
          <div style={{padding: '2px', top: '0px', right: '0px', position: 'absolute', boxSizing: 'border-box'}}>
            <img src="https://www.fasttrackracingteam.com/IMAGES/INGREDIENTS/GRAPHIC_you_got_this.png" style={{width: '30px'}}/>
          </div>
          }
          {typeof(youGotThis) === "boolean" && !youGotThis &&
          <div style={{padding: '2px', top: '0px', right: '0px', position: 'absolute', boxSizing: 'border-box'}}>
            <img src="https://www.fasttrackracingteam.com/IMAGES/INGREDIENTS/GRAPHIC_you_need_this.png" style={{width: '30px'}}/>
          </div>
          }
          <div style={{background: 'rgba(0, 0, 0, 0.5)', color: 'white', padding: '5px', bottom: '0px', position: 'absolute', width: '100%', boxSizing: 'border-box'}}>{ingredient.name}</div>

      </div>
    );

    if (!noLink) {
      ingredientRendered = (
      <div>
        <div onClick={() => { this.onKeyIngredientClick(ingredient.machine_name) }}>
        {ingredientRendered}
                </div>
                {showCabinetRemove &&
                <button style={{position: 'absolute', bottom: `0px`, cursor: 'pointer', width: '55px'}} onClick={() => this.removeFromCabinetChild(ingredient.machine_name)}>Remove</button>
                }
                {showRecipeRemove &&
                <button style={{position: 'absolute', bottom: `0px`, cursor: 'pointer', width: '55px'}} onClick = {() => this.props.removeFromRecipe(ingredient.machine_name)}>Remove</button>
                }
</div>
                );
    }

    ingredientRendered = (<div style={{whiteSpace: 'normal', display: 'inline-block', position: 'relative', height: (showCabinetRemove || showRecipeRemove?`22rem`:`20rem`), cursor: 'pointer', width: '55px'}}>{ingredientRendered}</div>);
    
    if (linkToIngredient) {
      return (
        <NavLink to={`/ingredient/${ingredient.machine_name}`}>
          {ingredientRendered}
        </NavLink>
      )
    }

    return ingredientRendered;
  }
}

function mapStateToProps(state) {
  const { authentication } = state;
  const { user } = authentication;
  return {
    user
  };
}


const connectedIngredientSlide = connect(mapStateToProps)(IngredientSlide);
export { connectedIngredientSlide as IngredientSlide };


// WEBPACK FOOTER //
// ./src/IngredientSlide/IngredientSlide.jsx